export default __webpack_public_path__ + "static/media/Panasonic.e59a7ff7.png";